var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { LayoutRefService } from '@metronic/app/core/services/layout/layout-ref.service';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { MenuAsideOffcanvasDirective } from '@metronic/app/core/directives/menu-aside-offcanvas.directive';
var DefaultLayoutComponent = /** @class */ (function (_super) {
    __extends(DefaultLayoutComponent, _super);
    function DefaultLayoutComponent(injector, layoutRefService) {
        var _this = _super.call(this, injector) || this;
        _this.layoutRefService = layoutRefService;
        return _this;
    }
    DefaultLayoutComponent.prototype.ngOnInit = function () {
        this.installationMode = UrlHelper.isInstallUrl(location.href);
    };
    DefaultLayoutComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.mMenuAsideOffcanvas = new MenuAsideOffcanvasDirective(_this.mAsideLeft);
            _this.mMenuAsideOffcanvas.ngAfterViewInit();
        });
        this.layoutRefService.addElement('header', this.mHeader.nativeElement);
    };
    return DefaultLayoutComponent;
}(ThemesLayoutBaseComponent));
export { DefaultLayoutComponent };
